import { render, staticRenderFns } from "./roomStatus.vue?vue&type=template&id=47be0a18&scoped=true&"
import script from "./roomStatus.vue?vue&type=script&lang=js&"
export * from "./roomStatus.vue?vue&type=script&lang=js&"
import style0 from "./roomStatus.vue?vue&type=style&index=0&id=47be0a18&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be0a18",
  null
  
)

export default component.exports